import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.addDocument`,
    defaultMessage: 'Add Document',
  },
  documentTemplate: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.documentTemplate`,
    defaultMessage: 'Document Template',
  },
  // AXHE-4106: both kinds are offered in one picker, grouped so it's clear
  // which is which — they're authored and configured in different places.
  documentsGroup: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.documentsGroup`,
    defaultMessage: 'Documents',
  },
  offerLetterTemplatesGroup: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.offerLetterTemplatesGroup`,
    defaultMessage: 'Offer letter templates',
  },
  editDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.editDocument`,
    defaultMessage: 'Edit Document',
  },
  roleSelectLabel: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.roleSelectLabel`,
    defaultMessage: '{role} Role',
  },
  updateDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.updateDocument`,
    defaultMessage: 'Update Document',
  },
  uniqueSigners: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.uniqueSigners`,
    defaultMessage: 'A user can only be assigned to one role.',
  },
  warningChangesToRoles: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.warningChangesToRoles`,
    defaultMessage:
      'Warning: Any changes to the roles will reflect to all instances of this document template within this document signing stage.',
  },
});
